module.exports = __webpack_public_path__ + "static/img/introduce-m@2x.1a1fd37c.png";